import loggingService from '../services/util/loggingService'
import dateService from '../services/util/dateService'

var isDebug = false
var path = '/BuildingSurvey/'

function get (http, id) {
    return http.get(`${path}Get?buildingSurveyId=${id}`)
}

function put (http, dto) {
    return http.put(path, dto)
}

function remove (http, id) {
    return http.post(`${path}Remove?buildingSurveyId=${id}`)
}

function search (http, searchDto) {
    loggingService.log(isDebug, 'Building Survey', 'Search by ' + searchDto.projectId)
    return http.post(`${path}Search`, searchDto)
}

function todo (http, searchDto) {
    loggingService.log(isDebug, 'Building Survey', 'Todo')
    return http.post(`${path}Todo`, searchDto).then(response => {
        response.data.forEach(value => {
            value.createdDate = dateService.convertToDate(value.createdDate)
        })
        return response
    })
}

function getUrlByObject (dto) {
    return path + dto.buildingSurveyId
}

var buildingWorkflowStatusEnum = {
    pendingRequestSubmission: 7000,
    pendingSHPOApproval: 7100,
    pendingSurvey: 7200,
    pendingSHPOReview: 7300,
    denied: 7400,
    completion: 7500
}

export default {
    get: get,
    put: put,
    remove: remove,
    search: search,
    todo: todo,
    getUrlByObject: getUrlByObject,
    buildingWorkflowStatusEnum: buildingWorkflowStatusEnum
}



// WEBPACK FOOTER //
// ./src/services/buildingSurveyService.js